document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ts-carousel-wrap').forEach(function (wrap) {
    var viewport = wrap.querySelector('.ts-viewport');
    var track = wrap.querySelector('[data-ts-track]');
    var prevBtn = wrap.querySelector('[data-ts-prev]');
    var nextBtn = wrap.querySelector('[data-ts-next]');
    if (!track || !viewport) return;

    // Duplicate cards for a seamless infinite loop
    var originalCards = Array.from(track.children);
    originalCards.forEach(function (card) {
      track.appendChild(card.cloneNode(true));
    });

    var position = 0;
    var speed = 0.4; // px per frame — lower = slower
    var isPaused = false;
    var loopWidth = 0;

    function calcLoopWidth() {
      loopWidth = 0;
      originalCards.forEach(function (card) {
        loopWidth += card.offsetWidth + 20; // 20 = gap
      });
    }
    calcLoopWidth();
    window.addEventListener('resize', calcLoopWidth);

    function animate() {
      if (!isPaused) {
        position += speed;
        if (position >= loopWidth) {
          position = 0;
        }
        track.style.transform = 'translateX(' + (-position) + 'px)';
      }
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);

    wrap.addEventListener('mouseenter', function () { isPaused = true; });
    wrap.addEventListener('mouseleave', function () { isPaused = false; });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        position += 320 + 20;
        if (position >= loopWidth) position -= loopWidth;
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        position -= 320 + 20;
        if (position < 0) position += loopWidth;
      });
    }
  });
});